import * as React from "react";
import { useCallback, useEffect, useState } from "react";

import {
    Datagrid,
    DateField,
    List,
    ListContextProvider,
    SearchInput,
    TextField,
    TextInput,
    useListContext,
    FunctionField,
    
} from "react-admin";
import { Divider, Tabs, Tab } from "@material-ui/core";

import { makeStyles } from "@material-ui/core/styles";

const orderFilters = [
    <SearchInput source="order_number" alwaysOn />,
    <TextInput label="Customer Name" source="user_name" />,
    <TextInput label="Store Name" source="store_name" />,
];

const useDatagridStyles = makeStyles({
    total: { fontWeight: "bold" },
});

const tabs = [
    { id: "buy", name: "buy" },
    { id: "rent", name: "rent" },
];


const TabbedDatagrid = (props) => {
    const listContext = useListContext();
    const { ids, filterValues, setFilters, displayedFilters } = listContext;
    const classes = useDatagridStyles();
    const [buy, setbuy] = useState([]);
    const [rent, setrent] = useState([]);

    useEffect(() => {
        if (ids && ids !== filterValues.order_status) {
            // eslint-disable-next-line default-case
            switch (filterValues.order_status) {
                case "buy":
                    setbuy(ids);
                    break;
                case "rent":
                    setrent(ids);
                    break;
            }
        }
    }, [ids, filterValues.order_status]);

    const handleChange = useCallback(
        (event, value) => {
            setFilters && setFilters({ ...filterValues, order_status: value }, displayedFilters);
        },
        [displayedFilters, filterValues, setFilters]
    );

    return (
        <>
            <Tabs variant="fullWidth" centered value={filterValues.order_status} indicatorColor="primary" onChange={handleChange}>
                {tabs.map((choice) => (
                    <Tab key={choice.id} label={choice.name} value={choice.id} />
                ))}
            </Tabs>
            <Divider />

            <div>
                {filterValues.order_status === "buy" && (
                    <ListContextProvider value={{ ...listContext, ids: buy }}>
                        <Datagrid {...props} optimized rowClick="edit">
                            <DateField source="date" showTime />
                            <TextField source="order_number" label="Order Number" />
                            <TextField source="name" label="Item" />
                            <TextField source="store_name" label="Store" />
                            <TextField source="user_name" label="Customer" />
                            <FunctionField label="Address" render={(record) => `${record.address_one}, ${record.city}, ${record.state} ${record.zipcode}`} />
                            <FunctionField label="Amount" render={(record) => `$${record.amount}`} className={classes.total} />
                            <FunctionField label="Fees" render={(record) => `$${record.fees}`} className={classes.total} />
                            <TextField source="status" />
                        </Datagrid>
                    </ListContextProvider>
                )}
                {filterValues.order_status === "rent" && (
                    <ListContextProvider value={{ ...listContext, ids: rent }}>
                        <Datagrid {...props} rowClick="edit">
                            <DateField source="date" showTime />
                            <TextField source="order_number" label="Order Number" />
                            <TextField source="name" label="Item" />
                            <TextField source="store_name" label="Store" />
                            <TextField source="user_name" label="Customer" />
                            <FunctionField label="Address" render={(record) => `${record.address_one}, ${record.city}, ${record.state} ${record.zipcode}`} />
                            <FunctionField label="Amount" render={(record) => `$${record.amount}`} className={classes.total} />
                            <FunctionField label="Fees" render={(record) => `$${record.fees}`} className={classes.total} />
                            <TextField source="status" />
                        </Datagrid>
                    </ListContextProvider>
                )}
            </div>
        </>
    );
};



export const OrderList = (props) => (
    <List {...props} filterDefaultValues={{ order_status: "buy" }} sort={{ field: "date", order: "DESC" }} perPage={10} filters={orderFilters}>
        <TabbedDatagrid />
    </List>
);